import { Controller } from "@hotwired/stimulus"

// «Vedi tutte» / «Mostra meno» delle sezioni della Dashboard (Opportunita e Azioni di pages/Dashboard.js): le righe
// oltre il `limite` sono nel DOM con `hidden` (React non le rendeva) e il pulsante le mostra o le nasconde.
// Nelle Azioni apre e chiude anche l'elenco dei progetti del promemoria della visura (visureAperte): l'elenco sta in un
// <template> e entra nel DOM solo aperto, come il {visureAperte && …} dell'originale; la freccia gira di 90°.
export default class extends Controller {
  static targets = ["riga", "etichetta", "elenco", "chevron"]
  static values = { limite: Number, tutte: Boolean }

  toggle() {
    this.tutteValue = !this.tutteValue
  }

  tutteValueChanged() {
    this.rigaTargets.forEach((r, i) => { r.hidden = !this.tutteValue && i >= this.limiteValue })
    if (this.hasEtichettaTarget) this.etichettaTarget.textContent = this.tutteValue ? "Mostra meno" : "Vedi tutte"
  }

  promemoria(event) {
    const pulsante = event.currentTarget
    const aperto = this.elenco()
    if (aperto) {
      aperto.remove()
    } else {
      pulsante.after(this.elencoTarget.content.cloneNode(true))
    }
    pulsante.setAttribute("aria-expanded", String(!aperto))
    this.chevronTargets.forEach((c) => c.classList.toggle("rotate-90", !aperto))
  }

  elenco() {
    return this.element.querySelector("[data-testid='dash-promemoria-elenco']")
  }
}
